/** Stable accent per service key for overview cards (no DB field). */
export type ServiceCardAccent = {
  main: string;
  soft: string;
  topBar: string;
  iconBg: string;
};

const ACCENTS: ServiceCardAccent[] = [
  { main: '#2563EB', soft: 'rgba(37,99,235,0.14)', topBar: 'linear-gradient(90deg,#1D4ED8,#60A5FA)', iconBg: 'rgba(37,99,235,0.18)' },
  { main: '#7C3AED', soft: 'rgba(124,58,237,0.14)', topBar: 'linear-gradient(90deg,#5B21B6,#C084FC)', iconBg: 'rgba(124,58,237,0.18)' },
  { main: '#059669', soft: 'rgba(5,150,105,0.14)', topBar: 'linear-gradient(90deg,#047857,#34D399)', iconBg: 'rgba(5,150,105,0.18)' },
  { main: '#EA580C', soft: 'rgba(234,88,12,0.14)', topBar: 'linear-gradient(90deg,#C2410C,#FB923C)', iconBg: 'rgba(234,88,12,0.18)' },
  { main: '#DB2777', soft: 'rgba(219,39,119,0.14)', topBar: 'linear-gradient(90deg,#BE185D,#F472B6)', iconBg: 'rgba(219,39,119,0.18)' },
  { main: '#0891B2', soft: 'rgba(8,145,178,0.14)', topBar: 'linear-gradient(90deg,#0E7490,#22D3EE)', iconBg: 'rgba(8,145,178,0.18)' },
  { main: '#CA8A04', soft: 'rgba(202,138,4,0.16)', topBar: 'linear-gradient(90deg,#A16207,#FACC15)', iconBg: 'rgba(202,138,4,0.2)' },
];

export function serviceCardAccent(serviceKey: string): ServiceCardAccent {
  let h = 2166136261;
  for (let i = 0; i < serviceKey.length; i++) {
    h ^= serviceKey.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return ACCENTS[Math.abs(h) % ACCENTS.length];
}
